var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    _vm._g(
      { attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 41 40" } },
      _vm.$listeners
    ),
    [
      _c("path", {
        attrs: {
          fill: "#F2F2F7",
          "fill-rule": "evenodd",
          d:
            "M10.256 0h20.493c3.398 0 4.633.357 5.872 1.02A6.894 6.894 0 0 1 39.48 3.9c.666 1.244 1.019 2.473 1.019 5.87v20.483c0 3.397-.353 4.63-1.02 5.874a6.946 6.946 0 0 1-2.86 2.858C35.382 39.648 34.148 40 30.75 40H10.256c-3.398 0-4.633-.353-5.876-1.015a6.96 6.96 0 0 1-2.86-2.858C.853 34.884.5 33.65.5 30.254V9.77c0-3.396.353-4.625 1.02-5.869A6.91 6.91 0 0 1 4.38 1.02C5.633.357 6.858 0 10.256 0z",
          "clip-rule": "evenodd"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#4285F4",
          d:
            "M32.5 20.059c0-.84-.074-1.639-.202-2.416H20.272v4.8h6.886c-.309 1.575-1.214 2.905-2.555 3.81v3.193h4.109c2.405-2.224 3.788-5.502 3.788-9.387z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#34A853",
          d:
            "M20.271 32.543c3.448 0 6.332-1.15 8.44-3.097l-4.108-3.193c-1.15.766-2.608 1.235-4.332 1.235-3.331 0-6.152-2.246-7.163-5.28H8.872v3.29c2.097 4.171 6.407 7.045 11.398 7.045z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FBBC05",
          d:
            "M13.109 22.209c-.266-.766-.405-1.586-.405-2.437s.15-1.671.405-2.437v-3.29H8.873a12.624 12.624 0 0 0 0 11.453l4.236-3.289z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#EA4335",
          d:
            "M20.271 12.055c1.884 0 3.565.65 4.896 1.916l3.64-3.64C26.604 8.266 23.718 7 20.27 7c-4.992 0-9.302 2.873-11.398 7.045l4.236 3.289c1.01-3.033 3.831-5.279 7.163-5.279z"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }